import { html, css, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class TicketsFlowComponent extends NexusComponent {
    static shadowRootOptions = { ...LitElement.shadowRootOptions, mode: 'open', delegatesFocus: true };
    static properties = {
        data: {
            state: true
        },
    };
    constructor() {
        super();
        this.data = {
            tickets: new Map(),
            discounts: new Map()
        };
        this.discountCode = null;
        this.ticketInputName = 'ticket_input';
        this.addEventListener('click', this.handleClick);
    }
    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
                display: block;  /* or display: block; */
                position: relative;
                margin: 0;
                width: 100%;
			}
		`;
    }

    connectedCallback() {
        super.connectedCallback();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.handleFormSubmit, false);
        let flowEvents = ['input', 'click', 'keydown'];
        flowEvents.forEach((type) => {
            this.form.addEventListener(type, (event) => {
                console.log('form', type, event);
                this.handleInteractionEvents(event);
            });
        });
        this.setEventListeners();
    }

    setEventListeners() {
        document.addEventListener('nexus.analytics.event.begin_checkout', this.onBeginCheckout.bind(this));
    }

    onBeginCheckout(event) {
        console.log('onBeginCheckout...', event, this.data);

    }

    handleTicketsInput(optionInput) {
        let ticketStepsContainer = this.querySelector('tickets-steps-container');
        console.log('handleTicketsInput');
        if (ticketStepsContainer) {
            let selector = `[name="${optionInput.getAttribute('name')}"]`;
            console.log('selected selector', selector);
            let input = ticketStepsContainer.querySelector(selector);
            if (input) {
                console.log('existing input', input);
                let closestTicketsInput = input.closest('tickets-input');
                console.log('closestTicketsInput', closestTicketsInput);
                input.value = this.data.tickets.get(optionInput.getAttribute('name')).value;
                closestTicketsInput.setAttribute('value', this.data.tickets.get(optionInput.getAttribute('name')).value);
            }
        }
    }

    handleInteractionEvents = (event) => {
        // event.preventDefault();
        console.log('handleInteractionEvents', event, event.composedPath(), event.composedPath()[0]);
        let ticketOption = event.composedPath()[0].closest('.ticket-option');
        if (ticketOption) {
            let optionInput = ticketOption.querySelector('.ticket-option-input');
            console.log('result for ticket-option-input from composed path first item:', optionInput);
            if (optionInput) {
                console.log('the option input actually exists');
                let option = event.composedPath()[0].closest('.ticket-option');
                if (option) {
                    console.log('existing closest option from first item of event composed path', option)
                    let label = option.querySelector('.ticket-label');
                    let price = option.querySelector('.ticket-price');
                    if (
                        label
                        &&
                        optionInput.value
                    ) {
                        // console.log('label and value!', label, event.composedPath()[0].value);
                        let ticketData = {
                            'value': parseFloat(parseFloat(optionInput.value).toFixed(2)),
                            'label': label.textContent,
                            'price': parseFloat(parseFloat(price.textContent).toFixed(2)),
                            'min': null,
                            'max': null,
                        };
                        let ticketInput = event.composedPath()[0].closest('tickets-input');
                        console.log('closest ticket input', ticketInput);
                        if (ticketData && ticketInput) {
                            ticketData.donation = ticketInput.donation;
                            console.log('ticketData and ticketInput', ticketData, ticketInput);
                        }
                        this.data.tickets.set(optionInput.getAttribute('name'), ticketData);
                        if (optionInput.min) {
                            this.data.tickets.get(optionInput.getAttribute('name')).min = parseInt(parseFloat(optionInput.min).toFixed());
                        }
                        if (optionInput.max) {
                            this.data.tickets.get(optionInput.getAttribute('name')).max = parseInt(parseFloat(optionInput.max).toFixed());
                        }
                        let ticketsOrderOverview = this.querySelector('tickets-order-overview');

                        if (ticketsOrderOverview) {
                            ticketsOrderOverview.data = Object.assign({}, this.data);
                        } else {
                            console.warn('no ticketsOrderOverview...', ticketsOrderOverview, ', please add a tickets-order-overview element within tickets-flow element');
                        }
                    }
                }

                this.handleTicketsInput(optionInput);
            }
        }

        let ticketsOrderOverview = this.querySelector('tickets-order-overview');
        // if (ticketsOrderOverview) {
        //     // ticketsOrderOverview.validDiscountCode = null;
        // }

        let tentativeDiscountCodeInput = event.composedPath()[0].closest('#discount_code_to_try');
        if (tentativeDiscountCodeInput) {
            this.discountCode = tentativeDiscountCodeInput.value;
            console.log('tentativeDiscountCodeInput', tentativeDiscountCodeInput.value, tentativeDiscountCodeInput);
            let discountCodeInput = this.querySelector('#discount_code');
            if (discountCodeInput) {
                discountCodeInput.value = this.discountCode;
                console.log('discountCodeInput', discountCodeInput, discountCodeInput.value);
            }
            // this.discountCode
        }

        if (
            event.type === 'keydown' &&
            event.key === 'Enter' &&
            tentativeDiscountCodeInput
          ) {
            event.preventDefault();
            this.handleDiscountCheck(event);
          }

        let discountCodeAddButton = event.composedPath()[0].closest('.button-discount-add');
        if (discountCodeAddButton) {
          this.handleDiscountCheck(event);
        }

        console.log('data', this.data.tickets);
        // to get a reactive object property, you must make a new object,
        // because otherwise the object is the same, only the properties change
        // this.data.tickets = Object.assign({}, this.data.tickets);
        // manually request a data update given an input change,
        // for updating tickets-flow js template
        this.requestUpdate();
    }

    handleDiscountCheck(event) {
        console.log('add button (or Enter) pressed – discount code is:', this.discountCode);
        
        if (!this.discountCode) return;
        
        // Only run on click or artificially from Enter
        if (event.type === 'click' || (event.type === 'keydown' && event.key === 'Enter')) {
            if (typeof window !== 'undefined' && typeof window.wp_ajax !== 'undefined') {
            wp_ajax = window.wp_ajax || { nexusContext: 'design-system' };
            }
        
            if (typeof wp_ajax !== 'undefined' && typeof wp_ajax.ajaxurl === 'undefined') {
            wp_ajax = {
                ajaxurl: `//wp-admin/admin-ajax.php`,
                nexusContext: 'wordpress',
            };
            }
        
            let data = { action: 'checkCoupon' };
            console.log(
            'done compositing wp_ajax for coupon check. wp_ajax object is now',
            wp_ajax
            );
        
            let f = document.createElement('form');
            let formData = new FormData(f);
            formData.set('coupon_code', this.discountCode);
            formData.set('action', 'checkCoupon');
        
            if (typeof wp_ajax !== 'undefined' && wp_ajax.ajaxnonce) {
            formData.set('security', wp_ajax.ajaxnonce);
            }
        
            let formObject = Object.fromEntries(formData);
            formObject = Object.assign(formObject, data);
        
            let ticketsOrderOverview = this.querySelector('tickets-order-overview');
            ticketsOrderOverview.checkingCodeValidity = true;
        
            let response = fetch(wp_ajax.ajaxurl, {
            method: 'POST',
            body: new URLSearchParams(formData),
            redirect: 'follow',
            });
            response
            .then((r) => {
                if (r.status === 200) {
                    console.log('awaited OK response', r);
                    r.json().then((json) => {
                        this.form.disabled = true;
                        console.log('json', json);
                        if (json && typeof json.success !== 'undefined') {
                            console.log('valid response received from call', json);
                            this.response = json;
                        }
                        if (json) {
                            if (json.success == false) {

                            }
                            if (json.success == true) {
                                if (json.data) {
                                    if (json.data.code) {
                                        console.log('received a valid code', json.data.code);
                                    }
                                    if (json.data.description) {
                                        console.log('received a description', json.data.description);
                                    }
                                    if (json.data.fixed_balance) {
                                        console.log('received a fixed_balance', json.data.fixed_balance);
                                    }
                                    if (json.data.percentage) {
                                        console.log('received a percentage', json.data.percentage);
                                    }
                                    if (json.data.tickets) {
                                        console.log('received tickets', json.data.tickets);
                                    }
                                    if (json.data.code) {
                                        ticketsOrderOverview.validDiscountCode = true;
                                        ticketsOrderOverview.checkingCodeValidity = false;
                                        this.data.discounts.set(json.data.code, Object.assign({}, json.data));
                                        ticketsOrderOverview.data = Object.assign({}, this.data);

                                    }
                                    if (json.data.error) {
                                        if (json.data.error == 'INVALID_CODE') {
                                            console.log('got error', json.data.error);
                                            if (ticketsOrderOverview) {
                                                ticketsOrderOverview.validDiscountCode = false;
                                                ticketsOrderOverview.checkingCodeValidity = false;
                                                let discountCodeElement = this.form.querySelector('#discount_code');
                                                if (discountCodeElement) {
                                                    discountCodeElement.value = ``; // empty it
                                                    document.removeChild(discountCodeElement); // remove it
                                                }
                                            }
                                        }
                                    }
                                }

                            }

                        }
                        this.requestUpdate();
                    });

                }
                ticketsOrderOverview.checkingCodeValidity = false;
            })
            .catch((error) => {
                console.warn(error);
            });
        }
    }

    handleSlotChange(event) {
        console.log('handleSlotChange', event);
        if (this.form) {
            console.log('form', this.form);
        }
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });
    }

    /**
     * 
     * @param {PointerEvent} event 
     */
    handleClick(event) {
        // let child = event.target;
        // let nav = child.querySelector('tickets-navigation');
        // console.log('nav', nav);
        console.log('tickets flow click', event);
    }

    render() {
        return html`
            <div class="tickets-flow" component-loaded>
            <slot @slotchange="${this.handleSlotChange}">...</slot>
            </div>
        `;
    }

    /**
     * Handle form submit in the web component
     * 
     * TODO: native form map without FormData mapping
     * (new web components feature coming somewhere in the future)
     * 
     * @param {*} event 
     */
    handleFormSubmit = (event) => {
        event.preventDefault();
        event.stopPropagation();
        console.log('handleFormSubmit', event);
        console.log('form validity', this.form.checkValidity(), this.form.reportValidity());

        let wp_ajax = {
            // "ajaxurl": "http:\/\/dev1.nexus.jaarbeurslive.nl\/wp-admin\/admin-ajax.php",
            ajaxurl: `/wp-json/jaarbeurs-tickets/v1/ticket-reservation-ajax/`,
            // "ajaxurl": this.form.action,
            // "ajaxnonce": "7c8fda9ae8"
        };
        let data = {
            action: 'ticketReservation',
            security: 'mèllon',
        };

        data = Object.assign(data, this.data);

        // important note, web components currently are not included as form elements because of scope
        // but there are movements in the standards so natively forms can be marked as being part of a form
        // but here is a nice solution that works for a lot of fields, without custom mapping
        let formData = new FormData(this.form);
        let formObject = Object.fromEntries(formData);
        formObject = Object.assign(formObject, data);
        let jsonString = JSON.stringify(formObject);

        if (this.form.checkValidity() == false) {

            console.log('data...', data);
            console.log('form to submit is', this.form, JSON.stringify(Object.fromEntries(new FormData(this.form))));

            // JSON.stringify(Object.fromEntries(new FormData(this.form))), // as json parsed from form data!
            // make json out of form and combine with ajax action data
            let response = fetch(wp_ajax.ajaxurl, {
                method: 'POST',
                // headers: {
                //     // "Content-Type": "application/json", // otherwise its plain text
                // },
                body: new URLSearchParams(new FormData(this.form)), // as form fields in request header
                // body: JSON.stringify(Object.fromEntries(new FormData(this.form))), // as json parsed from form data!
                // body: jsonString,
                redirect: 'follow',
            });
            console.log('response is', response);
            response.then((r) => {
                if (r.status === 200) {
                    console.log('awaited OK response', r);
                    // window.location.href = r.url;
                    r.json().then((json) => {
                        console.log('json', json);
                        if (json && typeof json.success !== 'undefined') {
                            console.log('valid response received from call', json);
                            this.response = json;
                        }
                        if (json && json.success == false) {
                            if (json.data && json.data.state) {
                                console.log('data with state received', json);
                                if (json.data.state == 'too_few_tickets') {
                                    this.response = json;
                                }
                            }
                        }
                        this.requestUpdate();
                    });

                }
                // if (r.status >= 300 && r.status < 303) {
                //     console.log('awaited redirect response', r);
                //     window.location.href = r.url;
                // }
            }).catch((error) => {
                console.warn(error);
            });
            this.triggerEventOnElement('nexus.analytics.form.submit.invalid', this, formObject);
        }

        if (this.form.checkValidity() == true) {
            this.triggerEventOnElement('nexus.analytics.form.submit.pre-submit', this, formObject);
            this.form.submit();
            this.triggerEventOnElement('nexus.analytics.form.submit.post-submit', this, formObject);
        }
    }
}

window.customElements.define('tickets-flow', TicketsFlowComponent);